
import { Component, Vue } from 'vue-property-decorator'
// @ts-ignore
import DefaultImage from '@/assets/common_images/default_image.png'
import commonService from '@/services/common-service'
/* eslint-disable */
enum EDIT_TYPE {
    UPDATE = 0,
    CREATE = 1
}
/* eslint-disable */

@Component({})
export default class MediaCircle extends Vue {
    private DialogVisible: boolean = false
    private DialogTitle: string = ''
    private isLoading: boolean = false
    private loadingMsg: string = '数据加载中'
    private editType: EDIT_TYPE = EDIT_TYPE.CREATE
    private canIopen: boolean = true
    private defaultLogo = DefaultImage
    private mediaList: any = []

    private mounted() {
        this.initData()
    }

    private async initData() {
        this.showLoading()
        const result = await commonService.getMediaCircleList()
        this.hideLoading()
        if (result.status === 200) {
            this.mediaList = result.data
        }
    }
    private showLoading(msg = '') {
        if (msg) {
            this.loadingMsg = msg
        }
        this.isLoading = true
    }

    private hideLoading() {
        this.isLoading = false
    }

    private onUpdateMediaCircle(id: number) {
        const { href } = this.$router.resolve({ 
            name: 'MediaCircleEdit',
            params: { id: String(id) } 
        })
        window.open(href, '_blank')
    }

    private onDeleteMediaCircle(id: number) {
        this.$confirm('是否确定删除该媒体圈?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(async () => {
            this.showLoading('媒体圈删除中')
            const params = { id }
            const result = await commonService.deleteMediaCircle(params)
            this.hideLoading()
            if (result.status === 200) {
                this.$message({
                    type: 'success',
                    message: '删除成功',
                    showClose: true
                })
                this.initData()
            }
        })
    }
}
